import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, reset } from 'redux-form';
import _ from 'lodash';
import moment from 'moment';
import {
  renderFieldText,
  renderFieldTextarea,
  renderCheckbox,
  renderSelect,
  renderFieldRadio,
  renderFieldCheckbox,
  renderDatePickerWithLabel,
  renderHiddenFieldText,
  renderStarRating
} from './base-components';
import {
  LABEL_POSITION_TOP,
  LABEL_POSITION_LEFT,
  FILES_URL,
  DATE_FORMAT
} from './constant';
import { updateWorkingForm } from '../myprofile/actions';
import uploaderIcon from '../../assets/img/icons/uploader-icon.svg';
import ImageCropper from './uploader-image-with-cropper';
import AllFilesDropOnly from './uploader-files-only';
import trashIcon from '../../assets/img/icons/trash.svg';
import appIcons from './appIcons';
import LocalStrings from '../../languages';

const CheckoutForm = props => {
  const {
    session,
    dynamicForm,
    savedForm,
    workingDynamicForm,
    productCategories,
    productSubCategories,
    deviceSize,
    isAppCall = false,
    reloadForm,
    eventDetails
  } = props;

  useEffect(() => {
    let workingForm = dynamicForm;
    _.map(dynamicForm, (item, index) => {
      var check = _.filter(savedForm, function(saved) {
        return saved.name === item.name;
      });
      if (item.key === 'file') {
        if (
          check &&
          check.length > 0 &&
          check[0].value &&
          check[0].value.length > 0
        ) {
          var exhistingFileArray = [];
          _.map(check[0].value, file => {
            if (file != '') {
              var f1 = file.split('/').pop();
              var f2 = f1.substr(0, f1.lastIndexOf('_'));
              var ext = f1.split('.').pop();
              var fileName = f2 + '.' + ext;
              var fileObj = { file: file, filename: fileName };
              exhistingFileArray.push(fileObj);
            }
          });
          item.fileArray = exhistingFileArray;
        } else {
          item.fileArray = [];
        }
      } else if (item.key === 'group') {
        if (item.type === 'products') {
          var proObj = {
            productimages: '',
            productcategory: '',
            productsubcategory: '',
            producttitle: '',
            productinfo: ''
          };
          var proArrVal = [proObj];

          if (
            check &&
            check.length > 0 &&
            check[0].value &&
            check[0].value.length > 0
          ) {
            proArrVal = check[0].value;
          }
          item.recordArray = proArrVal;
        } else if (item.type === 'coupons') {
          var couObj = {
            coupontitle: '',
            couponabout: '',
            couponecode: '',
            couponvalidtill: ''
          };
          var couArrVal = [couObj];

          if (
            check &&
            check.length > 0 &&
            check[0].value &&
            check[0].value.length > 0
          ) {
            couArrVal = check[0].value;
          }
          item.recordArray = couArrVal;
        } else if (item.type === 'deals') {
          var dealObj = { dealtitle: '', dealabout: '', dealvalidtill: '' };
          var dealArrVal = [dealObj];

          if (
            check &&
            check.length > 0 &&
            check[0].value &&
            check[0].value.length > 0
          ) {
            dealArrVal = check[0].value;
          }
          item.recordArray = dealArrVal;
        }
      }
      workingForm[index] = item;
    });

    props.updateWorkingForm({ form: workingForm });
  }, [props.callsForm, props.isSaved]);

  useEffect(() => {}, [savedForm]);

  // File Field Sestion Start
  const onFilesDrop = (data, name) => {
    var checkEventFormFile = _.filter(workingDynamicForm.form, obj => {
      return obj.key === 'file' && obj.name === name;
    });

    var fileArray = checkEventFormFile[0].fileArray;
    fileArray.push(data);

    props.updateWorkingForm(workingDynamicForm);
  };

  const onFileAvailable = available => {
    props.dynamicFileChanged(available);
  };

  const onFilesRemove = (index, name) => {
    var checkEventFormFile = _.filter(workingDynamicForm.form, obj => {
      return obj.key === 'file' && obj.name === name;
    });

    var newFileArray = checkEventFormFile[0].fileArray;
    _.pullAt(newFileArray, index);

    props.updateWorkingForm(workingDynamicForm);
    props.dynamicFileChanged(true);
  };

  const renderFiles = (accept, name, workingFileType) => {
    var fileArray = [];
    var maxfile = 1;
    var existingFilesCount = 1;
    if (
      workingDynamicForm &&
      workingDynamicForm.form &&
      workingDynamicForm.form.length > 0
    ) {
      var checkEventFormFile = _.filter(workingDynamicForm.form, obj => {
        return obj.key === 'file' && obj.name === name;
      });

      fileArray =
        checkEventFormFile.length > 0 ? checkEventFormFile[0].fileArray : [];
      maxfile =
        checkEventFormFile.length > 0 ? checkEventFormFile[0].maxupload : 1;
      existingFilesCount = checkEventFormFile.length > 0 ? fileArray.length : 1;
    }

    return (
      <>
        {_.map(fileArray, (item, index) => {
          var filePreview = '';
          var fileName = '';
          var fileOld = true;

          if (item && item.file) {
            var file = item.file;
            fileName = item.filename;
            filePreview = `${FILES_URL}/${file}?api_key=${props.session.apiKey}&session_token=${props.session.sessionToken}`;
            fileOld = true;
            var n = file.search(';base64,');
            if (n > 0) {
              fileOld = false;
              filePreview = item.file;
            }
          }

          var icon = appIcons.fileDefaultIcon;
          if (fileName != '') {
            var fileType = fileName.split('.').pop();

            if (
              fileType == 'svg' ||
              fileType == 'png' ||
              fileType == 'jpg' ||
              fileType == 'jpeg'
            ) {
              icon = appIcons.fileImageIcon;
            } else if (fileType == 'pdf') {
              icon = appIcons.fileDocumentIcon;
            }
          }

          return (
            <div key={`key-${index}`} className="col-12">
              <div className={`uploaded-attachment-displaybox`}>
                <div className="row m-0">
                  <div className="col-2 col-sm-2 col-md-1 p-0 text-center">
                    <div className="file-icons">{icon}</div>
                  </div>
                  <div className="col-7 col-sm-8 col-md-10 p-0 custom-text1-normal-secondary">
                    <div className="file-name">{fileName}</div>
                  </div>
                  <div className="col-3 col-sm-2 col-md-1 p-0 text-right d-flex">
                    {fileOld ? (
                      <a
                        className="action-button"
                        href={`${filePreview}&download=true`}
                        title="Download"
                      >
                        <div className="file-icons">
                          {appIcons.downloadIcon}
                        </div>
                      </a>
                    ) : (
                      ''
                    )}
                    <img
                      onClick={() => onFilesRemove(index, name)}
                      className="action-button cursor-pointer"
                      src={trashIcon}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        <div className="col-12 form-group">
          {existingFilesCount < maxfile ? (
            <AllFilesDropOnly
              onFileSave={data => onFilesDrop(data, name)}
              onFileChnageLocally={bool => onFileAvailable(bool)}
              accept={accept}
              className="content-files-dropbox"
              insideImage={uploaderIcon}
              insideImageStyle={{
                width: 30,
                height: 30,
                margin: '0px 10px 0px'
              }}
              insideText={
                deviceSize.isMobile || isAppCall
                  ? workingFileType == 'image'
                    ? LocalStrings.myprofile_click
                    : workingFileType == 'video'
                    ? LocalStrings.myprofile_click_video
                    : LocalStrings.myprofile_click_file
                  : workingFileType == 'image'
                  ? LocalStrings.myprofile_drag
                  : workingFileType == 'video'
                  ? LocalStrings.myprofile_drag_video
                  : LocalStrings.myprofile_drag_file
              }
            />
          ) : (
            <div className="content-files-dropbox-disabled">
              <span className="custom-text1-normal-secondary">
                {LocalStrings.dynamic_form_max_file_upload}
              </span>
            </div>
          )}
        </div>
      </>
    );
  };
  // File Field Sestion End

  // Gorup Field Sestion Start
  const onProductImageSave = (img, index, name) => {
    var checkEventFormGroup = _.filter(workingDynamicForm.form, obj => {
      return obj.key === 'group' && obj.name === name;
    });

    var newRecordArray = checkEventFormGroup[0].recordArray;
    newRecordArray[index].productimages = img == '' ? '' : img;

    props.updateWorkingForm(workingDynamicForm);
  };

  const onProductImageChange = imageAvailable => {};

  const handleGroupTextField = (e, name, subname, index) => {
    var value = e.target.value;

    if (
      workingDynamicForm &&
      workingDynamicForm.form &&
      workingDynamicForm.form.length > 0
    ) {
      var checkEventFormGroup = _.filter(workingDynamicForm.form, obj => {
        return obj.key === 'group' && obj.name === name;
      });

      var newRecordArray = checkEventFormGroup[0].recordArray;

      newRecordArray[index][subname] = value;

      if (name === 'products' && subname === 'productcategory') {
        newRecordArray[index].productsubcategory = '';
        props.autofill(`productsubcategory[${index}]`, '');
      }
    }

    props.updateWorkingForm(workingDynamicForm);
  };

  const handleGroupDateField = (e, name, subname, index) => {
    var value = moment(e).format(DATE_FORMAT);

    if (
      workingDynamicForm &&
      workingDynamicForm.form &&
      workingDynamicForm.form.length > 0
    ) {
      var checkEventFormGroup = _.filter(workingDynamicForm.form, obj => {
        return obj.key === 'group' && obj.name === name;
      });

      var newRecordArray = checkEventFormGroup[0].recordArray;

      newRecordArray[index][subname] = value;
    }

    props.updateWorkingForm(workingDynamicForm);
  };

  const handleGroupArray = (action, index, name) => {
    var checkEventFormGroup = _.filter(workingDynamicForm.form, obj => {
      return obj.key === 'group' && obj.name === name;
    });

    var newRecordArray = checkEventFormGroup[0].recordArray;
    var groupType = checkEventFormGroup[0].type;
    if (action === 'add') {
      if (groupType === 'products') {
        var proObj = {
          productimages: '',
          productcategory: '',
          productsubcategory: '',
          producttitle: '',
          productinfo: ''
        };
        newRecordArray.push(proObj);
      } else if (groupType === 'coupons') {
        var couObj = {
          coupontitle: '',
          couponabout: '',
          couponecode: '',
          couponvalidtill: ''
        };
        newRecordArray.push(couObj);
      } else if (groupType === 'deals') {
        var dealObj = { dealtitle: '', dealabout: '', dealvalidtill: '' };
        newRecordArray.push(dealObj);
      }
    } else {
      _.pullAt(newRecordArray, index);
    }

    props.updateWorkingForm(workingDynamicForm);
  };

  const renderGroups = (groupType, name) => {
    var recordArray = [];
    var maxEnteries = 1;
    var existingEntriesCount = 1;
    var groupfields = [];
    var categories = [];

    if (
      workingDynamicForm &&
      workingDynamicForm.form &&
      workingDynamicForm.form.length > 0
    ) {
      var checkEventFormGroup = _.filter(workingDynamicForm.form, obj => {
        return obj.key === 'group' && obj.name === name;
      });

      recordArray =
        checkEventFormGroup.length > 0
          ? checkEventFormGroup[0].recordArray
          : [];
      maxEnteries =
        checkEventFormGroup.length > 0 ? checkEventFormGroup[0].maxentries : 1;
      groupfields =
        checkEventFormGroup.length > 0
          ? checkEventFormGroup[0].groupfields
          : [];
      existingEntriesCount = recordArray.length;
    }

    if (
      productCategories &&
      productCategories.data &&
      productCategories.data.length > 0
    ) {
      _.map(productCategories.data, (item, index) => {
        let cobj = { value: item.name, text: item.name };
        categories.push(cobj);
      });
    }

    if (recordArray.length > 0) {
      return _.map(recordArray, (item, index) => {
        var productImage = '';
        var subcategories = [];
        if (groupType === 'products' && recordArray.length > 0) {
          var image = item.productimages;
          if (image && image != '') {
            var n = image.search(';base64,');
            if (n > 0) {
              productImage = image;
            } else {
              productImage = `${FILES_URL}/${image}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
            }
          }
        }

        var categoryname = item.productcategory ? item.productcategory : '';
        var matchCat = _.filter(productCategories.data, cat => {
          return cat.name == categoryname;
        });
        var categoryid = matchCat.length > 0 ? matchCat[0].id : '';

        if (
          categoryid != '' &&
          productSubCategories &&
          productSubCategories.data &&
          productSubCategories.data.length > 0
        ) {
          var matchSubCate = _.filter(productSubCategories.data, sc => {
            return sc.categoryid == categoryid;
          });

          _.map(matchSubCate, (item, index) => {
            let scobj = { value: item.name, text: item.name };
            subcategories.push(scobj);
          });
        }

        return (
          <>
            <div className="col-md-12" key={`key-${index}`}>
              <div className="row">
                <div className="col-11 pr-0">
                  {groupType === 'products' ? (
                    <div className="row">
                      <div className="col-12 col-sm-4 col-md-4 col-lg-3 product-image-section">
                        <ImageCropper
                          displaySize={{ width: 200, height: 200 }} // For image display style
                          requiredSize={{ width: 100, height: 100 }} // For image size required validation
                          cropperSize={{ width: 50, height: 50 }} // Cropper display size. Note its add 50px for padding
                          onImageSave={img =>
                            onProductImageSave(img, index, name)
                          }
                          onImageChange={bool => onProductImageChange(bool)}
                          imagepath={productImage}
                          imageType="jpg"
                          className="drop-zone-area-custom-image"
                          insideImage={uploaderIcon}
                          insideImageStyle={{
                            width: 36,
                            height: 36,
                            margin: '40px 0px 10px'
                          }}
                          insideText={
                            deviceSize.isMobile || isAppCall
                              ? LocalStrings.myprofile_click_100
                              : LocalStrings.myprofile_drag_100
                          }
                        />
                      </div>
                      <div className="col-12 col-sm-8 col-md-8 col-lg-9">
                        <div className="row">
                          <div className="col-md-12">
                            <Field
                              name={
                                groupfields && groupfields.length > 0
                                  ? `${groupfields[3].name}[${index}]`
                                  : ''
                              }
                              label={
                                groupfields && groupfields.length > 0
                                  ? `#${index + 1} ${groupfields[3].label}`
                                  : ''
                              }
                              placeholder={LocalStrings.form_label_title}
                              type="text"
                              component={renderFieldText}
                              mandatory="false"
                              maxlength={
                                groupfields && groupfields.length > 0
                                  ? groupfields[3].maxlen
                                  : ''
                              }
                              onChange={e =>
                                handleGroupTextField(
                                  e,
                                  name,
                                  groupfields[3].name,
                                  index
                                )
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <Field
                              name={
                                groupfields && groupfields.length > 0
                                  ? `${groupfields[1].name}[${index}]`
                                  : ''
                              }
                              label={
                                groupfields && groupfields.length > 0
                                  ? groupfields[1].label
                                  : ''
                              }
                              placeholder={LocalStrings.kSelectPlaceholder}
                              component={renderSelect}
                              mandatory={false}
                              opts={categories}
                              onChange={e =>
                                handleGroupTextField(
                                  e,
                                  name,
                                  groupfields[1].name,
                                  index
                                )
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <Field
                              name={
                                groupfields && groupfields.length > 0
                                  ? `${groupfields[2].name}[${index}]`
                                  : ''
                              }
                              label={
                                groupfields && groupfields.length > 0
                                  ? groupfields[2].label
                                  : ''
                              }
                              placeholder={LocalStrings.kSelectPlaceholder}
                              component={renderSelect}
                              mandatory={false}
                              opts={subcategories}
                              onChange={e =>
                                handleGroupTextField(
                                  e,
                                  name,
                                  groupfields[2].name,
                                  index
                                )
                              }
                            />
                          </div>
                          <div className="col-md-12">
                            <Field
                              name={
                                groupfields && groupfields.length > 0
                                  ? `${groupfields[4].name}[${index}]`
                                  : ''
                              }
                              label={
                                groupfields && groupfields.length > 0
                                  ? groupfields[4].label
                                  : ''
                              }
                              placeholder={LocalStrings.form_ph_description}
                              component={renderFieldTextarea}
                              mandatory="false"
                              maxlength={
                                groupfields && groupfields.length > 0
                                  ? groupfields[4].maxlen
                                  : ''
                              }
                              onChange={e =>
                                handleGroupTextField(
                                  e,
                                  name,
                                  groupfields[4].name,
                                  index
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : groupType === 'coupons' ? (
                    <div className="row">
                      <div className="col-md-12">
                        <Field
                          name={
                            groupfields && groupfields.length > 0
                              ? `${groupfields[0].name}[${index}]`
                              : ''
                          }
                          label={
                            groupfields && groupfields.length > 0
                              ? `#${index + 1} ${groupfields[0].label}`
                              : ''
                          }
                          placeholder={LocalStrings.form_label_title}
                          type="text"
                          component={renderFieldText}
                          mandatory="false"
                          maxlength={
                            groupfields && groupfields.length > 0
                              ? groupfields[0].maxlen
                              : ''
                          }
                          onChange={e =>
                            handleGroupTextField(
                              e,
                              name,
                              groupfields[0].name,
                              index
                            )
                          }
                        />
                      </div>
                      <div className="col-md-12">
                        <Field
                          name={
                            groupfields && groupfields.length > 0
                              ? `${groupfields[1].name}[${index}]`
                              : ''
                          }
                          label={
                            groupfields && groupfields.length > 0
                              ? groupfields[1].label
                              : ''
                          }
                          placeholder={LocalStrings.form_ph_description}
                          component={renderFieldTextarea}
                          mandatory="false"
                          maxlength={
                            groupfields && groupfields.length > 0
                              ? groupfields[1].maxlen
                              : ''
                          }
                          onChange={e =>
                            handleGroupTextField(
                              e,
                              name,
                              groupfields[1].name,
                              index
                            )
                          }
                        />
                      </div>
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-md-6">
                            <Field
                              name={
                                groupfields && groupfields.length > 0
                                  ? `${groupfields[3].name}[${index}]`
                                  : ''
                              }
                              label={
                                groupfields && groupfields.length > 0
                                  ? groupfields[3].label
                                  : ''
                              }
                              component={renderDatePickerWithLabel}
                              mandatory="false"
                              // selected={moment()}
                              onChange={e =>
                                handleGroupDateField(
                                  e,
                                  name,
                                  groupfields[3].name,
                                  index
                                )
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <Field
                              name={
                                groupfields && groupfields.length > 0
                                  ? `${groupfields[2].name}[${index}]`
                                  : ''
                              }
                              label={
                                groupfields && groupfields.length > 0
                                  ? groupfields[2].label
                                  : ''
                              }
                              placeholder={LocalStrings.form_label_coupon_code}
                              type="text"
                              component={renderFieldText}
                              mandatory="false"
                              maxlength={
                                groupfields && groupfields.length > 0
                                  ? groupfields[2].maxlen
                                  : ''
                              }
                              onChange={e =>
                                handleGroupTextField(
                                  e,
                                  name,
                                  groupfields[2].name,
                                  index
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : groupType === 'deals' ? (
                    <div className="row">
                      <div className="col-md-12">
                        <Field
                          name={
                            groupfields && groupfields.length > 0
                              ? `${groupfields[0].name}[${index}]`
                              : ''
                          }
                          label={
                            groupfields && groupfields.length > 0
                              ? `#${index + 1} ${groupfields[0].label}`
                              : ''
                          }
                          placeholder={LocalStrings.form_label_title}
                          type="text"
                          component={renderFieldText}
                          mandatory="false"
                          maxlength={
                            groupfields && groupfields.length > 0
                              ? groupfields[0].maxlen
                              : ''
                          }
                          onChange={e =>
                            handleGroupTextField(
                              e,
                              name,
                              groupfields[0].name,
                              index
                            )
                          }
                        />
                      </div>
                      <div className="col-md-12">
                        <Field
                          name={
                            groupfields && groupfields.length > 0
                              ? `${groupfields[1].name}[${index}]`
                              : ''
                          }
                          label={
                            groupfields && groupfields.length > 0
                              ? groupfields[1].label
                              : ''
                          }
                          placeholder={LocalStrings.form_ph_description}
                          component={renderFieldTextarea}
                          mandatory="false"
                          maxlength={
                            groupfields && groupfields.length > 0
                              ? groupfields[1].maxlen
                              : ''
                          }
                          onChange={e =>
                            handleGroupTextField(
                              e,
                              name,
                              groupfields[1].name,
                              index
                            )
                          }
                        />
                      </div>
                      <div className="col-md-12">
                        <Field
                          name={
                            groupfields && groupfields.length > 0
                              ? `${groupfields[2].name}[${index}]`
                              : ''
                          }
                          label={
                            groupfields && groupfields.length > 0
                              ? groupfields[2].label
                              : ''
                          }
                          component={renderDatePickerWithLabel}
                          mandatory="false"
                          // selected={moment()}
                          onChange={e =>
                            handleGroupDateField(
                              e,
                              name,
                              groupfields[2].name,
                              index
                            )
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                <div className="col-1 pl-0">
                  {maxEnteries > 1 && existingEntriesCount > 1 ? (
                    <div
                      className="dynamic-options-actions-buttons pull-right"
                      onClick={() => handleGroupArray('remove', index, name)}
                    >
                      <img
                        className="file-delete-button cursor-pointer"
                        src={trashIcon}
                        alt=""
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
            <div
              className={`col-md-12 border-bottom ${
                index == recordArray.length - 1 ? 'pb-1' : 'mb-3'
              }`}
            >
              {existingEntriesCount < maxEnteries &&
              index == recordArray.length - 1 ? (
                <div className="pull-right">
                  <button
                    type="button"
                    className="custom-button-primary-md"
                    onClick={() =>
                      handleGroupArray('add', existingEntriesCount, name)
                    }
                  >
                    {groupType === 'products'
                      ? LocalStrings.button_new_product
                      : groupType === 'deals'
                      ? LocalStrings.button_new_deal
                      : groupType === 'coupons'
                      ? LocalStrings.button_new_coupon
                      : ''}
                  </button>
                </div>
              ) : (
                ''
              )}
            </div>
          </>
        );
      });
    }
  };
  // Gorup Field Sestion End

  return (
    <>
      {_.map(dynamicForm, (form, index) => {
        if (form?.hidden || _.includes(form.name, 'hi_')) return <></>;

        var name = form.name;
        var filetype = '';
        var accept = '';
        if (form.key == 'file') {
          filetype = form.filetype;
          if (filetype == 'image') {
            accept = 'image/*';
          } else if (filetype == 'video') {
            accept = 'video/*';
          } else if (filetype == 'audio') {
            accept = 'audio/*';
          } else if (filetype == 'document') {
            accept = 'application/*';
            // accept = 'application/pdf,application/vnd.ms-excel,application/msword,application/zip';
          }
        }
        const isFieldReadOnly = _.includes(name, 'ro_') && !session.isadmin;

        return (
          <div
            key={index}
            style={form.key == 'rating' ? { marginBottom: -16 } : {}}
          >
            {form.key == 'textinput' || form.key == 'numberinput' ? (
              <Field
                name={name}
                label={form.label}
                type={form.key == 'textinput' ? 'text' : 'number'}
                component={renderFieldText}
                mandatory={`${form.required}`}
                maxlength={form.maxlen}
                labelposition={LABEL_POSITION_TOP}
                disabled={isFieldReadOnly}
              />
            ) : form.key == 'textarea' ? (
              <Field
                name={name}
                label={form.label}
                component={renderFieldTextarea}
                mandatory={`${form.required}`}
                maxlength={form.maxlen}
                labelposition={LABEL_POSITION_TOP}
                disabled={isFieldReadOnly}
              />
            ) : form.key == 'checkboxes' ? (
              <Field
                name={name}
                label={form.label}
                type="checkbox"
                component={renderCheckbox}
                mandatory={`${form.required}`}
                opts={form.options}
                disabled={isFieldReadOnly}
              />
            ) : form.key == 'radiobuttons' ? (
              <div className="form-group row">
                <label className="control-label-top col-sm-12">
                  {form.label}
                  {form.required ? (
                    <span className="label-mandatory">*</span>
                  ) : (
                    ''
                  )}
                </label>
                <div className="col-sm-12 col-sm-offset-0">
                  {_.map(form.options, (opt, index) => {
                    const fieldChecked = opt?.value == form?.value ?? false;
                    return (
                      <div key={index} style={{ display: 'flex' }}>
                        <Field
                          name={name}
                          label={opt.text}
                          value={opt.value}
                          type="radio"
                          component={renderFieldRadio}
                          disabled={isFieldReadOnly}
                          fieldChecked={fieldChecked}
                        />
                      </div>
                    );
                  })}
                  <Field name={form.id} component={renderHiddenFieldText} />
                </div>
              </div>
            ) : form.key == 'dropdown' ? (
              <Field
                name={name}
                label={form.label}
                placeholder={LocalStrings.kSelectPlaceholder}
                component={renderSelect}
                mandatory={`${form.required}`}
                opts={form.options}
                labelposition={LABEL_POSITION_TOP}
                disabled={isFieldReadOnly}
              />
            ) : form.key == 'datepicker' ? (
              <Field
                name={name}
                label={form.label}
                component={renderDatePickerWithLabel}
                mandatory={`${form.required}`}
                selected={moment()}
                disabled={isFieldReadOnly}
              />
            ) : form.key == 'hyperlink' ? (
              <div className="form-group row">
                <label className="control-label-top col-sm-12">
                  {form.label}
                </label>
                <a
                  href={form.link}
                  target="blank"
                  className="col-sm-12 col-sm-offset-0 custom-text-color"
                >
                  {form.link}
                </a>
              </div>
            ) : form.key == 'label' ? (
              <label>{form.label}</label>
            ) : form.key == 'paragraph' ? (
              <p>{form.label}</p>
            ) : form.key == 'file' ? (
              <div className="row">
                <label className="control-label-top col-sm-12">
                  {form.label}
                </label>
                {/* {renderFiles(accept, name)} */}
                {renderFiles(accept, name, form?.filetype)}
              </div>
            ) : form.key == 'group' ? (
              <div className="form-group row">
                <label className="control-label-top col-sm-12">
                  {form.label}
                </label>
                {renderGroups(form.type, name)}
              </div>
            ) : form.key == 'singlecheckbox' && name == 'isnetworking' ? (
              <div className="form-group row">
                <div className="col-sm-12">
                  <Field
                    name={name}
                    label={form.label}
                    component={renderFieldCheckbox}
                    value="1"
                    type="checkbox"
                    disabled={isFieldReadOnly}
                  />
                </div>
              </div>
            ) : form.key == 'rating' ? (
              <>
                <Field
                  name={name}
                  label={form.label}
                  component={renderStarRating}
                  mandatory={form.required}
                  labelposition={LABEL_POSITION_TOP}
                  changeGenRating={props.changeGenRating}
                  color={eventDetails?.resource?.themecolor}
                  disabled={isFieldReadOnly}
                />
              </>
            ) : (
              ''
            )}
          </div>
        );
      })}
    </>
  );
};

const mapStateToProps = state => ({
  session: state.session,
  workingDynamicForm: state.workingDynamicForm,
  deviceSize: state.deviceSize,
  eventDetails: state.eventDetails
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ updateWorkingForm }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutForm);
